import {
  DEFAULT_SKILLS as SKILL_CATALOG,
  resolveAbilityId,
} from "../catalogs/characterSystemCatalog";
import Skill from "./Skill";

const catalogMatch = (skill) =>
  SKILL_CATALOG.find(
    (entry) =>
      entry.id === skill.id ||
      entry.catalogId === skill.catalogId ||
      entry.legacyName === skill.name
  );

export const DEFAULT_SKILLS = SKILL_CATALOG.map((entry) => ({
  id: entry.id,
  catalogId: entry.catalogId,
  modifier: 0,
  abilityId: entry.abilityId,
  playerSkillPoints: 0,
  isClassSkill: false,
}));

class Skills {
  constructor(json) {
    const supplied = json.skillsList ?? [];
    this.skillsList = DEFAULT_SKILLS.map((defaultSkill) => {
      const existing = supplied.find(
        (skill) => catalogMatch(skill)?.catalogId === defaultSkill.catalogId
      );
      return new Skill({
        ...defaultSkill,
        ...existing,
        id: existing?.id?.startsWith("default-")
          ? existing.id
          : defaultSkill.id,
        catalogId: defaultSkill.catalogId,
        abilityId: resolveAbilityId(
          existing?.abilityId ||
            existing?.mainCharacteristicName ||
            defaultSkill.abilityId
        ),
        name: undefined,
      });
    }).concat(
      supplied
        .filter((skill) => !catalogMatch(skill))
        .map((skill) => new Skill(skill))
    );
    this.availableSkillPoints = Number(json.availableSkillPoints);
  }
}

export default Skills;
